import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: '[appBoldFontWeight]',
  standalone: true,
})
export class BoldFontWeightDirective implements OnChanges {
  @Input('appBoldFontWeight') filterString!: string;

  @Input() customClass: string = 'highlight';

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['filterString']) {
      this.applyHighlight();
    }
  }

  private applyHighlight() {
    const originalContent = this.elementRef.nativeElement.textContent;

    if (originalContent && this.filterString) {
      const regex = new RegExp(`(${this.filterString})`, 'gi');
      const replacedHtml = originalContent.replace(
        regex,
        `<span class="${this.customClass}">$1</span>`
      );
      this.renderer.setProperty(
        this.elementRef.nativeElement,
        'innerHTML',
        replacedHtml
      );
    }
    if (originalContent && !this.filterString) {
      this.renderer.setProperty(
        this.elementRef.nativeElement,
        'innerHTML',
        originalContent
      );
    }
  }
}
